<ws-modal-wrapper [headerLabel]="modalTitle"
                  (save)="save()"
                  (cancel)="cancel()"
                  [useAceStyles]="true">
    <div class="row">
        <div class="d-flex justify-content-center align-items-center">
            <label class="d-inline-block me-2 mb-0">Name:</label>
            <input type="text"
                   style="width: 285px;"
                   [(ngModel)]="search.searchName"
                   maxlength="100"
                   class="form-control">
        </div>
    </div>
    @if (searchType === 0) {
        <div class="row">
            <div class="d-flex justify-content-center align-items-center">
                <label>
                    <input [(ngModel)]="search.isRyanInternal" type="checkbox"> Only visible to Ryan personnel
                </label>
            </div>
        </div>
    }
</ws-modal-wrapper>
